import { PurposeEnum, StatusEnum } from '@needle-management/shared-models';
import {
  Column,
  CreateDateColumn,
  Entity,
  PrimaryGeneratedColumn,
  UpdateDateColumn,
  VersionColumn,
} from 'typeorm';

@Entity('material_request')
export class MaterialRequestEntity {
  @PrimaryGeneratedColumn("increment", { name: 'material_req_id' })
  materialReqId: number;

  @Column('datetime', {
    name: 'date',
  })
  date: Date;

  @Column('varchar', {
    name: 'module',
  })
  module: string;

  @Column('varchar', {
    name: 'shift',
  })
  shift: string;

  @Column('int', {
    name: 'machine_id',
  })
  machineId: number;

  @Column('int', {
    name: 'needle_model_id',
  })
  needleModelId: number;

  @Column('int', {
    name: 'needle_size_id',
  })
  needleSizeId: number;

   @Column('int', {
    name: 'needle_point_id',
  })
  needlePointId: number;

  @Column('varchar', {
    name: 'needle_Quantity',
  })
  needleQuantity: string;
  

  @Column('varchar', {
    name: 'mechanic_Name',
  })
  mechanicName: string;

  @Column({
    type: 'enum',
    enum: PurposeEnum,
    nullable: true,
    name: 'purpose',
  })
  purpose: PurposeEnum;

  @Column({
    type: 'enum',
    enum: StatusEnum,
    nullable: true,
    name: 'status',
  })
  status: StatusEnum;

  
  @Column('int', {
    name: 'stock_in_id',
  })
  stockInId: number;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    name: 'created_user',
    nullable: true,
  })
  createdUser: string;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    name: 'updated_user',
    nullable: true,
  })
  updatedUser: string;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;

  @Column('boolean', {
    name: 'is_active',
    default: true,
  })
  isActive: boolean;
}
